import { Banner, FeatureCollection, Store } from './../../../core/models';
import {  Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {  Observable } from 'rxjs';
import {  map, startWith } from 'rxjs/operators';
import * as _ from 'lodash';
import { StoreAddWizard } from '../store-add-wizard';
import { WizardPageComponent } from 'src/app/core/wizard/wizard-page-component';
import { StoreAddService } from '../store-add.service';
import { StoreDetailService } from 'src/app/core/store/store-detail.service';
import { Store as NgrxStoreType } from '@ngrx/store';
import { AppState } from 'src/app/app-state';
import { KeyIndicatorType } from 'src/app/core/user-preferences/key-indicator-type.enum';
import { LicenseType } from 'src/app/auth/authorization/license-type.enum';
import { BannerService } from 'src/app/core/banner/banner.service';
import { metersToMiles } from 'src/app/core/util/math-utils';
import { FeatureType } from 'src/app/core/federation/feature/feature-type.enum';
import Marker = google.maps.Marker;
import { MtnMap } from '../../mtn-map';
import { GridAlgorithm, MarkerClusterer } from "@googlemaps/markerclusterer";
import {  MatTableDataSource } from '@angular/material/table';
import { SalesSqftDisplayType } from 'src/app/core/user-preferences/sales-sqft-display-type.enum';
import { SalesVolumeDisplayType } from 'src/app/core/user-preferences/sales-volume-display-type.enum';
import { ProjectionStatus } from './projection-status.enum';
import * as ExcelJS from 'exceljs';
import { WizardRunnerService } from 'src/app/core/wizard/wizard-runner.service';
// import { SiteOutOfProfileWizard } from './site-out-of-profile/site-out-of-profile-wizard';
import { SqftWarningWizard } from './sqft-warning-alert/sqft-warning-wizard';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { ToastService } from 'src/app/core/toast/toast.service';
import { DemographicDataService } from 'src/app/core/services/demographic-data.service';
import { StoreAddPdfPageComponent } from './store-add-pdf-page/store-add-pdf-page.component';
import 'html2canvas';



@Component({
  standalone: false,
  selector: 'mtn-store-add',
  templateUrl: './store-add.component.html',
  styleUrls: ['./store-add.component.scss'],
})
export class StoreAddComponent
  extends WizardPageComponent<StoreAddWizard>
  implements OnInit
{
  key = 'store-add'; // Unique key for this wizard page
  newUserForm: FormGroup;
  keyIndicatorForm: FormGroup;
  stores: Array<{ StoreName: string; DefaultFit: string }> = [];
  filteredStores: Observable<{ StoreName: string; DefaultFit: string }[]>;
  mapOptions: any;
  areaSales = 0;
  isInitialized = false;
  isSubmitted = false;
  weeklySalesUpperRange: any;
  weeklySalesLowerRange: any;
  closetCompetitor: any;
  nearestStore: any;
  store: Store;
  volume: any;
  userPreferences: any;
  _marketArea: any;
  comparisonStoreCount: any;
  comparisonSalesVolume: any;
  comparisonSalesSqft: any;
  coardinates: any;
  isActionButtonEnabled: boolean = true;
  keyIndicator:string;
  regionType:string;
  regionValue:string;
  demographicRegionType:string;
  demographicRegionValue:string;
  selectedStore: string = '';
  selectedStoreUUID: any = 1;
  selectedStoreID: any = 1;
  dataSource = new MatTableDataSource<any>([]);
  isLoading = false;
  KeyIndicatorType = KeyIndicatorType;
  licenseType: LicenseType;
  subjectBanner: Banner;
  marketAreaCoardinates: FeatureCollection;
  driveTimeCoardinates: any = '';
  ringMilesCoardinates: any = '';
  bannerData: any = '';
  bannerCBSAAverages: any;
  map: MtnMap;
  futureStoreStatus = ['NEW_CONSTRUCTION', 'PLANNED', 'PROPOSED'];
  nearestFutureStoreDistance : any = 0;
  nearestFutureStoreName = '--';
  futureStoreCount = 0;
  markerClusterer: MarkerClusterer;
  private readonly DEFAULT_CLUSTER_ZOOM = 9;
  densityClass: string;
  totalLength: number = 0;
  competititveData : any = [];
  demographicData : any = [];
  totalSalesProjectionStatus = '--';
  sqftProjectionStatus = '--';
  cbsaName: any = '';
  bannerCoardinates: any;
  showDetails = false;
  fitScoreLimit = 80;
  storeSqftAverage :any = [];
  isGrocerSelected = false;
  showPdfPreview = false;
  // Start disabled until required data is loaded
  exportPdfButton = false;
  exportPdfButtonText = 'Export PDF';
  sqftWarningData: {
  percentageDifference: number;
  avg: string;
  averageSqft: number;
  grocerName: string;
};

  @ViewChild(StoreAddPdfPageComponent) pdfComponent!: StoreAddPdfPageComponent;
  @ViewChild('mapContainer', { read: ElementRef }) mapContainer!: ElementRef;

  selectedStoreFitType: string = '';

  constructor(
    protected ngrxStore: NgrxStoreType<AppState>,
    private fb: FormBuilder,
    private http: HttpClient,
    private wizardRunner: WizardRunnerService,
    public storeAddService: StoreAddService,
    public storeDetailService: StoreDetailService,
    private bannerService: BannerService,
    private hitTracking: HitTrackingService,
    private toaster: ToastService,
    private demographicDataService: DemographicDataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.exportButtonDisableText = 'Export is enabled only when a sales range (lower or upper) is provided, and both demographic and competitive data are available.';
    this.coardinates = this.wizard.model;
    this.initWizardButtons();
    this.initializeForms();
    this.mapInitialization();
    this.buildMarkerClusterer();
    this.fetchGrocerFromCSV();
    this.loadMarketArea();
    this.fetchGrocerSqftAVG();
  }

  initWizardButtons() {
    this.title =`<img src="assets/images/PointClickIcon.png" height="40"  alt=""> ${this.wizard.model.location}`;
    this.closeButtonText = 'close';
    this.exportButtonText = 'Export Data'
    this.exportButton = false;
    this.hideActionSpinner = true;
    this.actionButtonText = 'Project Grocery Sales';
  // Keep PDF export disabled until demographic/competitive data are ready
  this.exportPdfButton = false;
    this.exportPdfButtonText = 'Export PDF';

  }
  initializeForms() {
    this.newUserForm = this.fb.group({
      sqft: [
        null,
        [Validators.required, Validators.min(5000), Validators.max(250000)],
      ],
      grocer: ['', Validators.required],
      salesArea: [null,[Validators.min(0),Validators.max(250000) ]], // Optional field for projected store sales area
    });

  }
  mapInitialization() {
    this.mapOptions = {
      key: 'map-search-3',
      center: { lat: this.wizard.model.lat, lng: this.wizard.model.lng },
      featureType: FeatureType.STORE,
      zoom: 14,
      controlConfiguration: {
        isGoogleSearchEnabled: false,
        isFiltersEnabled: false,
        isMapModeEnabled: false,
        isMapTypeEnabled: false,
        isRecenterEnabled: false,
        isStreetViewEnabled: false,
        isTiltAndRotateEnabled: false,
        isZoomEnabled: true,
      },
      onMarkerClick: (marker: Marker) => this.handleMarkerClick(marker),
    };
  }
  fetchGrocerFromCSV() {
    this.http.get('/assets/images/Banner & FIT Update 11.2025.xlsx', {
      responseType: 'arraybuffer'
    })
    .subscribe(async (data: ArrayBuffer) => {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(data);
      const worksheet = workbook.worksheets[0];
      const headers: string[] = [];
      const jsonData: any[] = [];

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) {
          row.eachCell(cell => headers.push(String(cell.value ?? '')));
        } else {
          const rowData: any = {};
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            rowData[headers[colNumber - 1]] = String(cell.value ?? '');
          });
          jsonData.push(rowData);
        }
      });

      this.stores = jsonData.map((row: any) => ({
        StoreName: row.banner_name?.toString().trim(),
        DefaultFit: row.store_fit?.toString().trim()
      })).filter(x => x.StoreName && x.DefaultFit);

      this.initializeAutocomplete();
    });
  }
  fetchGrocerSqftAVG() {
    this.http
      .get('/assets/images/AvgSQFT.csv', { responseType: 'text' })
      .subscribe((data) => {
        const rows = data.split('\n').slice(1).filter(row => row.trim().length > 0);

        this.storeSqftAverage = rows.map((row) => {
          const values = row.match(/((\".*?\")|[^,]+)/g)?.map(item => item.replace(/(^\")|(\"$)/g, '').trim()
        );

          if (values && values.length >= 3) {
            return {
              StoreName: values[0],
              storeId: values[1],
              average: values[2].replace(/,/g, '')
            };
          }
        }).filter(Boolean);

      });
  }





  addMarker(lat: number, lng: number): void {
    const newMarker = new google.maps.Marker({
      position: { lat, lng },
      map: this.map,
    });

    // Add the marker to the clusterer if necessary
    if (this.markerClusterer) {
      this.markerClusterer.addMarker(newMarker);
    } else {
      // If not using a clusterer, add it directly to the map
      newMarker.setMap(this.map);
    }
  }
  handleMarkerClick(marker: Marker): void {
    this.map.select(marker['id']);
  }
  buildMarkerClusterer(): void {

    this.markerClusterer = new  MarkerClusterer({
      map: this.map,
      markers: [],

      algorithm: new GridAlgorithm({
        maxZoom: this.DEFAULT_CLUSTER_ZOOM,
        gridSize: 120,
      }),

    });
  }

  loadCBSAAveragesForBanner() {
    this.isLoading = true;
    const request: any = {
      fips: this.marketAreaCoardinates.getFeature()?.id,
      salesSqftDisplayType: SalesSqftDisplayType.SALES_AREA,
      salesVolumeDisplayType: SalesVolumeDisplayType.WEEKLY,
    };
    if (this.selectedStoreUUID) {
      this.storeAddService
        .getBannerCBSAAverages(this.selectedStoreUUID, request)
        .subscribe({
          next: (result: any) => {
            this.isLoading = false;
            this.bannerCBSAAverages = result;
            console.log("cbsa area sales : - ",this.areaSales);
            this.calculateBannerProjection(this.weeklySalesLowerRange, this.weeklySalesUpperRange, this.areaSales);
          },
          error: (err: any) => {
            this.isLoading = false;
            console.error('Error loading CBSA Averages:', err);
            this.clearDependentValues(); // Clear dependent values on error
          },
        });
    } else {
      this.clearDependentValues(); // Clear dependent values if selectedStoreUUID is undefined
    }
  }

  // New method to clear dependent values
  clearDependentValues(): void {
    this.bannerCBSAAverages = undefined;
    this.weeklySalesUpperRange = undefined;
    this.weeklySalesLowerRange = undefined;
    this.areaSales = 0; // Reset area sales if needed
    this.totalSalesProjectionStatus = '--';
    this.sqftProjectionStatus = '--';
    this.exportButton = false; // Disable export button
    // Add any other dependent values that need to be cleared
  }

  loadMarketArea() {
    this.isLoading = true;
    this.storeAddService.loadMarketArea(this.wizard.model).subscribe({
      next: (result: any) => {
        this.marketAreaCoardinates = result;
        this.cbsaName =
          this.marketAreaCoardinates?.getFeature()?.properties?.name;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error loading market area:', err);
      },
    });
  }

  private initializeAutocomplete(): void {
    this.filteredStores = this.newUserForm.get('grocer')!.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterGrocers(value || ''))
    );
  }

  private filterGrocers(
    value: string
  ): { StoreName: string; DefaultFit: string }[] {
    const filterValue = value?.toLowerCase() || '';
    return this.stores.filter((store) =>
      store?.StoreName?.toLowerCase()?.includes(filterValue)
    );
  }

  displayGrocerName(store: any): string {
    if (typeof store === 'string') {
      return store;
    }
    return store?.StoreName || '';
  }

  onGrocerOptionSelected(event: any): void {
    const selectedStore = event.option.value;
    if (selectedStore && selectedStore.DefaultFit) {
      this.selectedStoreFitType = selectedStore.DefaultFit;
      console.log('Selected store with fit type:', selectedStore);
    }
    this.isGrocerSelected = true;
  }

  // Called when user types something in the input field
  onGrocerInput() {
    this.isGrocerSelected = false; // Reset grocer selection when the user starts typing
    this.selectedStoreFitType = ''; // Reset fit type when user starts typing
  }

  onAction(): any {
    if (!this.newUserForm.valid) {
      this.newUserForm.markAllAsTouched();
      console.error('Form is invalid');
      return;
    }
    if (!this.isGrocerSelected) {
      this.newUserForm.get('grocer')?.setErrors({ notSelected: true });
      console.error('Grocer is not selected');
      return;
    }
    const enteredSqft = this.toNumber(this.newUserForm.value.sqft); // Convert sqft value
    let shouldFetchData = true;
    this.storeSqftAverage.forEach((element: any) => {
      if(element.storeId == this.selectedStoreID){
        shouldFetchData = false;
        const averageSqft = this.toNumber(element.average); // Convert average sqft
        if (averageSqft > 0) {
          const sqftDifference = enteredSqft - averageSqft;
          const percentageDifference = (sqftDifference / averageSqft) * 100;

          if (percentageDifference <= -25) {
             const grocer = this.newUserForm.value.grocer;
             const grocerName = typeof grocer === 'string' ? grocer : grocer?.StoreName;
             this.checkSQftWarning('Below',averageSqft.toLocaleString(),grocerName,Math.abs(Number(percentageDifference.toFixed(2))));
             const avg = 'Below';
            this.sqftWarningData = {
              percentageDifference,
              avg,
              averageSqft,
              grocerName
            };
          } else if (percentageDifference >= 25) {
            const grocer = this.newUserForm.value.grocer;
             const grocerName = typeof grocer === 'string' ? grocer : grocer?.StoreName;
             this.checkSQftWarning('Above',averageSqft.toLocaleString(),grocerName,percentageDifference.toFixed(2));
             const avg = 'Above';
            this.sqftWarningData = {
              percentageDifference,
              avg,
              averageSqft,
              grocerName
            };
          } else {
            this.sqftWarningData = null;
            this.fetchData();
          }

        } else {
          console.error("Invalid sqft values. Ensure sqft input and average values are numeric.");
        }

      }
    })
    if(shouldFetchData){
      this.fetchData();
    }

  }

  fetchData(){

    this.futureStoreCount = 0;
    this.isSubmitted = true;
    this.isInitialized = false;
    this.resetSalesRanges();
    this.fetchWeeklySalesRange();
  }
  toNumber(value: any): number {
    if (typeof value === 'string') {
      return parseFloat(value.replace(/,/g, '').trim()) || 0;
    }
    return Number(value) || 0;
  }

  onExportData() : any {
    if(this.weeklySalesLowerRange || this.weeklySalesUpperRange || this.demographicData.length>0 || this.competititveData.length>0){
    this.exportData();
    }
  }

  onExportPdf() : any {
    this.captureMapAndExportPdf();
  }
  fetchFutureStores() {
    this.storeAddService
      .getFutureStore({
        lat: this.wizard.model.lat,
        lng: this.wizard.model.lng,
      })
      .subscribe(
        (response) => this.handleFutureStoresResponse(response),
        (error) => this.handleError(error)
      );
  }

  handleFutureStoresResponse(response: any) {
    response.forEach((element: any) => {
      if (this.futureStoreStatus.includes(element.currentStatus)) {
        const newDistance = element?.distance;
        if (this.nearestFutureStoreDistance < newDistance) {
          this.nearestFutureStoreDistance = Number(newDistance).toFixed(2);
          this.nearestFutureStoreName = element?.storeName;
        }
        this.futureStoreCount++;
      }
    });
  }

  resetSalesRanges(): void {
    this.weeklySalesUpperRange = undefined;
    this.weeklySalesLowerRange = undefined;
  }

  grocerSelectionReset() {
    this.showDetails = false;
    this.isSubmitted = false;
    this.exportButton = false;
    this.isActionButtonEnabled = true;
    this.selectedStoreFitType = ''; // Reset fit type
    this.newUserForm.controls['grocer'].reset();
  }
  grocerSqftReset(){
    this.showDetails = false;
    this.isSubmitted = false;
    this.exportButton = false;
    this.isActionButtonEnabled = true;
  }

  private fetchWeeklySalesRange(): void {
    const { lng, lat } = this.wizard.model;
    const { sqft, grocer, salesArea } = this.newUserForm.value;

    const grocerName = typeof grocer === 'string' ? grocer : grocer?.StoreName;
    const fitType = this.selectedStoreFitType || 'Conventional';
    console.log("Using grocer:", grocerName, "fit-type:", fitType);

    this.storeAddService
      .getWeeklySalesRange({
        long: lng,
        lat: lat,
        total_area: sqft,
        sales_area: salesArea,
        banner: grocerName,
        fit_type : fitType
      })
      .subscribe(
        (response) => {
          this.handleWeeklySalesResponse(response)
        },
        (error) => this.handleError(error)
      );
  }

  private handleWeeklySalesResponse(response: any): void {
    this.isInitialized = true;

    const grocer = this.newUserForm.value.grocer;
    const grocerName = typeof grocer === 'string' ? grocer : grocer?.StoreName;

    const trackingData = {
      grocer: grocerName,
      location: this.wizard?.model?.location,
      sqft: this.newUserForm?.value?.sqft,
      ...this.wizard?.model.currentSearchlocation
    };

    this.hitTracking
      .hitTheUserTracking(
        USER_TRACKING_SOURCES.STORE_ADD_COMPONENT,
        trackingData,
        USER_TRACKING_ACTIONS.PROJECT_GROCERY_SALES,
        USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.PROJECT_GROCERY_SALES]
      )
      .subscribe(() => {});


      this.showDetails = true;
      this.isSubmitted = true;
      this.isActionButtonEnabled = false;
      this.fetchclosetCompetitor(
        1,
        this.wizard.model.lat,
        this.wizard.model.lng,
        false
      );
      this.fetchFutureStores();
      if (this.selectedStore != grocerName) {
        this.selectedStore = grocerName;
        this.onGrocerSelected(grocerName);
      }

    // this.densityClass = response?.data[0]?.density_class;
    if (response?.predict?.ensemble_lower && response?.predict?.ensemble_upper && response.data.length>0 ) {
      const densityTypes = ['Rural', 'Suburban', 'Urban'];
      const densityClassWithPostfix = response?.data[0]?.density_class || '';

      this.densityClass =
        densityTypes.find((type) => densityClassWithPostfix.startsWith(type)) ||
        null;
        let ensemble_lower: any;
        let ensemble_upper: any;

        if (response?.predict) {
          ({ ensemble_lower, ensemble_upper } = response.predict);
        }
      const areaSales = response.data[0].area_sales;
      const fitScore= response.data[0].fit_score;
      console.log("🚀 ~ fit score condition apply here ", areaSales)
      console.log("Response is : - ",response);

      this.areaSales = areaSales;
      if(fitScore < 100)
      {
        this.areaSales = areaSales * (fitScore/100);
        console.log("🚀 ~ this.areaSales: ", this.areaSales);
      }
      this.weeklySalesLowerRange = ensemble_lower;
      this.weeklySalesUpperRange = ensemble_upper;
      this.enableExportButton();
    }else{
      this.sqftProjectionStatus = '--';
      this.totalSalesProjectionStatus = '--';
      this.weeklySalesLowerRange = undefined;
      this.weeklySalesUpperRange = undefined;
      this.exportButton = false;
    }
  }
  enableExportButton(){
    if((this.isSubmitted && (this.weeklySalesLowerRange || this.weeklySalesUpperRange) ) &&( this.demographicData.length > 0  && this.competititveData.length > 0)){
      this.exportButton = true
    }
  }

  private calculateBannerProjection(
    ensemble_lower: number,
    ensemble_upper: number,
    area_sales: number
  ) {
    if (
      ensemble_lower &&
      ensemble_upper &&
      area_sales &&
      this.bannerCBSAAverages
    ) {
      const lowerTotalSales = Number((ensemble_lower * area_sales).toFixed(2));
      const upperTotalSales = Number((ensemble_upper * area_sales).toFixed(2));
      const lowerSalesPerSqft = Number(ensemble_lower.toFixed(2));
      const upperSalesPerSqft = Number(ensemble_upper.toFixed(2));
      const { averageTotalSales, averageSalesPerSquareFoot } =
        this.bannerCBSAAverages;

      // Determine total sales projection status
      this.totalSalesProjectionStatus = this.calculateProjectionStatus(
        averageTotalSales,
        lowerTotalSales,
        upperTotalSales
      );

      // Determine square footage sales projection status
      this.sqftProjectionStatus = this.calculateProjectionStatus(
        averageSalesPerSquareFoot,
        lowerSalesPerSqft,
        upperSalesPerSqft
      );
    }
  }

  private calculateProjectionStatus(
    value: number,
    lowerValue: number,
    upperValue: number
  ): ProjectionStatus {
    if (value > lowerValue && value < upperValue) {
      return ProjectionStatus.Average;
    } else if (value > upperValue) {
      return ProjectionStatus.BelowAverage;
    } else {
      return ProjectionStatus.AboveAverage;
    }
  }

  private fetchclosetCompetitor(
    bannerId: number,
    latitude: number,
    longitude: number,
    bannerFlag: boolean
  ): void {
    this.storeAddService
      .getNearestStore(bannerId, latitude, longitude, bannerFlag)
      .subscribe(
        (stores: any) => {
          stores.distance = metersToMiles(stores?.distance);

          this.closetCompetitor = stores;
        },
        (error) => this.handleError(error)
      );
  }
  private fetchNearestStore(
    bannerId: number,
    latitude: number,
    longitude: number,
    bannerFlag: boolean
  ): void {
    this.storeAddService
      .getNearestStore(bannerId, latitude, longitude, bannerFlag)
      .subscribe(
        (stores: any) => {
          stores.distance = metersToMiles(stores?.distance);
          this.nearestStore = stores;
        },
        (error) => this.handleError(error)
      );
  }

  private handleError(error: any): void {
    this.isInitialized = true;
    console.error('API Error:', error);
  }
  onMapReady(map: MtnMap): void {
    this.map = map;
    if (this.map) {
      this.map.options.recenterOffsetX = 450; // Width of spotlight panel
      this.addMarker(this.wizard.model.lat, this.wizard.model.lng);
    }
    console.log('Map container element:', this.mapContainer?.nativeElement);
  }

  onGrocerSelected(selectedValue: string): void {
    this.isGrocerSelected = true;

    // Only set fit type if not already set by autocomplete selection
    if (!this.selectedStoreFitType) {
      const csvStore = this.stores.find(store => store.StoreName === selectedValue);
      this.selectedStoreFitType = csvStore?.DefaultFit || 'Conventional';
      console.log('Selected store from CSV (fallback):', csvStore);
    }

    const request: any = {
      query: selectedValue.trim(),
    };
    this.bannerService.search(request).subscribe({
      next: (result: any) => {
        // Assuming you have a variable `selectedStoreName` that holds the name you want to match
        const selectedStoreName = selectedValue; // Replace with the actual source of the name

        // Find the store that matches the selected name
        const matchedStore = result.content.find((store: any) => store.name === selectedStoreName);

        if (matchedStore) {
          this.selectedStoreUUID = matchedStore.uuid;
          this.selectedStoreID = matchedStore.id;
          this.fetchNearestStore(
            this.selectedStoreID,
            this.wizard.model.lat,
            this.wizard.model.lng,
            true
          );
          // Load banner CBSA averages
        } else {
          this.selectedStoreUUID = null;
          this.selectedStoreID = null;
          this.nearestStore = null;
          console.warn('No store found with the name:', selectedStoreName);
          // Handle the case where no matching store is found
        }
        this.loadCBSAAveragesForBanner();

      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error fetching demographic data:', err);
      },
    });
    // Handle your logic here for the final selected value
  }

  getStateAbbreviation(cbsaName: string): string {
    const parts = cbsaName?.split(',');
    return parts?.length > 1 ? parts[1].trim() : cbsaName;
  }

  exportData(): void {
    const formData = {
      Grocer: this.newUserForm.controls.grocer.value,
      SQFT: this.newUserForm.controls.sqft.value,
    };

    const summaryData = {
      'Projected Total Weekly Sales Range': this.weeklySalesLowerRange && this.weeklySalesUpperRange
      ? `$${this.formatNumberWithTwoDecimals(Number((this.weeklySalesLowerRange * this.areaSales).toFixed(2)))} - $${this.formatNumberWithTwoDecimals(Number((this.weeklySalesUpperRange * this.areaSales).toFixed(2)))}`
      : '--',
      'Projected Weekly Sales Per SQFT Range': this.weeklySalesLowerRange && this.weeklySalesUpperRange
        ? `$${this.formatNumberWithTwoDecimals(this.weeklySalesLowerRange.toFixed(2))} - $${this.formatNumberWithTwoDecimals(this.weeklySalesUpperRange.toFixed(2))}`
        : '--',
      'Total Sales Projection Relative to Market Area': this.totalSalesProjectionStatus || '--',
      'Sales Per SQFT Projection Relative to Market Area': this.sqftProjectionStatus || '--',
      'Future openings (Count within 7 mins / closest)': this.futureStoreCount && this.nearestFutureStoreDistance
        ? `${this.futureStoreCount} / ${this.nearestFutureStoreDistance} miles (${this.nearestFutureStoreName || '--'})`
        : '--',
      'Closest Competitor': this.closetCompetitor?.storeName && this.closetCompetitor?.distance
        ? `${this.closetCompetitor.storeName} - ${this.closetCompetitor.distance.toFixed(2)}`
        : '--',
      'Closest Sister Store': this.nearestStore?.bannerName && this.nearestStore?.distance
        ? `${this.nearestStore.bannerName} - ${this.nearestStore.distance.toFixed(2)}`
        : '--',
    };

    const workbook = new ExcelJS.Workbook();

    // Utility function to auto-fit columns
    const autoFitColumns = (worksheet: ExcelJS.Worksheet): void => {
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const value = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, value.length);
        });
        column.width = maxLength + 10; // Add padding
      });
    };

    // Utility function to set the "Open Sans" font for all cells
    const setOpenSansFont = (worksheet: ExcelJS.Worksheet): void => {
      worksheet.eachRow((row) => {
        row.eachCell((cell, index) => {
          // Skip header/title cells that already have custom styles
          if (!cell.style || !cell.style.font) {
            cell.font = { name: 'Open Sans', size: 12 }; // Set "Open Sans" font to each cell
          }
          if (index == 2) {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
          }
        });
      });
    };

    const generateFormAndSummarySheet = (workbook: ExcelJS.Workbook): void => {
      const worksheet = workbook.addWorksheet('Site & Sales Details');

      // Add title
      const titleCell = worksheet.getCell('A1');
      const secondTitleCell = worksheet.getCell('B1');
      titleCell.value = 'RetailStat Grocery Insights - Sales Projection Summary';
      titleCell.font = { bold: true, name: 'Open Sans', size: 12, color: { argb: 'FFFFFFFF' } };
      titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      secondTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      titleCell.alignment = { horizontal: 'left', vertical: 'middle' };
      const dateCell = worksheet.getCell('A2');
      const currentDate = new Date().toLocaleDateString(); // You can adjust the format as needed
      dateCell.value = `${currentDate}`;

      worksheet.addRow([]); // Empty row for spacing

      // Add Form Data section
      const row = worksheet.addRow(['Site Details']);
      row.getCell(1).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background
      row.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background
      worksheet.addRow(['Address', this.wizard.model.location || '--']);
      worksheet.addRow(['Market Area (CBSA)', this.cbsaName || '--']);
      worksheet.addRow(['Banner', formData.Grocer || '--']);
      worksheet.addRow(['Sales Area SQFT', this.areaSales ? this.formatWholeNumber(this.areaSales) : '--']);
      worksheet.addRow(['Total Area SQFT', this.formatWholeNumber(formData.SQFT) || '--']);
      worksheet.addRow([]); // Empty row for spacing

      worksheet.addRow([]); // Empty row for spacing

      // Add Summary Data section
      const salesProjectionRow = worksheet.addRow(['Sales Projection Overview']);
      salesProjectionRow.getCell(1).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      salesProjectionRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background
      salesProjectionRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background

      Object.entries(summaryData).forEach(([key, value]) => {
        worksheet.addRow([key, value || '--']);
      });

      // Apply auto-fit and general font style for all non-styled cells
      autoFitColumns(worksheet);
      setOpenSansFont(worksheet); // Apply "Open Sans" font to all general cells
    };

    const generateCompetitiveSheet = (workbook: ExcelJS.Workbook): void => {
      const worksheet = workbook.addWorksheet('Competition Summary');

      const titleCell = worksheet.getCell('A1');
      const secondTitleCell = worksheet.getCell('B1');
      const thirdTitleCell = worksheet.getCell('C1');
      titleCell.value = 'RetailStat Grocery Insights - Competition Summary';
      titleCell.font = { bold: true, name: 'Open Sans', size: 12, color: { argb: 'FFFFFFFF' } };
      titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      secondTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      thirdTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      titleCell.alignment = { horizontal: 'left', vertical: 'middle' };
      const dateCell = worksheet.getCell('A2');
      const currentDate = new Date().toLocaleDateString(); // You can adjust the format as needed
      dateCell.value = `${currentDate}`;

      worksheet.addRow([`Region :  ${this.regionValue ? this.regionValue : ''} ${this.splitAndTitleCase(this.regionType)}`, ]);

      worksheet.addRow([`Compare To : ${this.splitAndTitleCase(this.keyIndicator)}`]);


      worksheet.addRow([]); // Empty row for spacing

      const subTitleRow =  worksheet.addRow(['Banner', this.keyIndicator == KeyIndicatorType.SALES_SQFT ? 'Avg Sales Per SQFT' : 'Total Sales', 'Count']);
      subTitleRow.getCell(1).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      subTitleRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background
      subTitleRow.getCell(2).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      subTitleRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background
      subTitleRow.getCell(3).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      subTitleRow.getCell(3).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } }; // Blue background

      this.competititveData.forEach((data) => {
        const row:any = worksheet.addRow([data.name,`$${Number(data.value).toFixed(2)}` ,data.totalCount]);
        row.getCell(3).alignment = { horizontal: 'center', vertical: 'middle' };

      });

      // Apply auto-fit and general font style for all non-styled cells
      autoFitColumns(worksheet);
      setOpenSansFont(worksheet);  // Apply "Open Sans" font to all general cells
    };

    const generateDemographicSheet = (workbook: ExcelJS.Workbook): void => {
      const worksheet = workbook.addWorksheet('Demographic Profile');

      const titleCell = worksheet.getCell('A1');
      const secondTitleCell = worksheet.getCell('B1');
      titleCell.value = 'RetailStat Grocery Insights - Demographic Profile';
      titleCell.font = { bold: true, name: 'Open Sans', size: 12, color: { argb: 'FFFFFFFF' } };
      titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      secondTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0f1b4d' } };
      titleCell.alignment = { horizontal: 'left', vertical: 'middle' };
      const dateCell = worksheet.getCell('A2');
      const currentDate = new Date().toLocaleDateString(); // You can adjust the format as needed
      dateCell.value = `${currentDate}`;

      worksheet.addRow([`Region : ${this.demographicRegionValue ? this.demographicRegionValue : ''} ${this.splitAndTitleCase(this.demographicRegionType)}`, ]);


      worksheet.addRow([]); // Empty row for spacing

      this.demographicData.forEach((item) => {
        const subTitleRow =  worksheet.addRow([item.category]);
        subTitleRow.getCell(1).font = { name: 'Open Sans', bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
        subTitleRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } };
        subTitleRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '853399' } };

        Object.entries(item.data).forEach(([key, value]) => {
          worksheet.addRow([key, value]);
        });
        worksheet.addRow([]); // Empty row for spacing
      });

      // Apply auto-fit and general font style for all non-styled cells
      autoFitColumns(worksheet);
      setOpenSansFont(worksheet);  // Apply "Open Sans" font to all general cells
    };

    generateFormAndSummarySheet(workbook);
    generateCompetitiveSheet(workbook);
    generateDemographicSheet(workbook);

  // Save workbook as an Excel file
  workbook.xlsx.writeBuffer().then((buffer) => {
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);

    // Create a hidden anchor element
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${this.wizard.model.location || 'ExportedData'}.xlsx`; // Fallback to 'ExportedData' if location is undefined
    anchor.style.display = 'none'; // Hide the anchor element
    document.body.appendChild(anchor); // Append to body to ensure compatibility
    anchor.click(); // Trigger the click to initiate download
    document.body.removeChild(anchor); // Clean up after download
    window.URL.revokeObjectURL(url); // Release the object URL

      const trackingData = {
        grocer: this.newUserForm?.value?.grocer,
        location: this.wizard?.model?.location,
        sqft: this.newUserForm?.value?.sqft,
        ...this.wizard?.model.currentSearchlocation
      };

      this.hitTracking
        .hitTheUserTracking(
          USER_TRACKING_SOURCES.SALES_PROJECTION_EXPORT,
          trackingData,
          USER_TRACKING_ACTIONS.EXPORT_DATA,
          USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.EXPORT_DATA]
        )
        .subscribe();


    });

  }

  splitAndTitleCase(input: string): string {
    return input?.split('_') // Split by underscores
      .map(word => word[0] + word.slice(1).toLowerCase()) // Capitalize first letter only
      .join(' '); // Join with a space
  }
  formatNumberWithTwoDecimals(number) {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  formatWholeNumber(number) {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  handleChildData(data: string) {
    this.competititveData = data; // Update parent data with emitted data
    if(this.competititveData.length>0){
      this.enableExportButton();
    }
  }

  handleRegionAndCompareType(event:any){
    this.regionType = event.regionType;
    this.keyIndicator = event.keyIndicator;
    this.regionValue = event?.regionValue
  }

  handleRegionTypeAndValueEmitter(event:any){
    this.demographicRegionType = event.regionType;
    this.demographicRegionValue = event.regionValue;
    if(this.demographicData.length>0){
      this.enableExportButton();
    }
  }

  handleChildDataFromDemographic(data: any){
    this.demographicData = data;

    // Convert processed demographic data back to raw format for PDF component
    if(data && data.length > 0) {
      // Find demographic data from the processed data
      const demographicItem = data.find(item => item.category === 'Demographics');

      if(demographicItem && demographicItem.data) {
        // Create raw demographic data structure expected by PDF component
        const rawDemographics = {
          ethnicityAsian: parseFloat(demographicItem.data['Asian'] || '0') / 100,
          ethnicityHispanic: parseFloat(demographicItem.data['Hispanic'] || '0') / 100,
          ethnicityOther: parseFloat(demographicItem.data['Other'] || '0') / 100,
          ethnicityBlack: parseFloat(demographicItem.data['Black'] || '0') / 100,
          ethnicityWhite: parseFloat(demographicItem.data['White'] || '0') / 100,
          populationEstimate: parseInt(demographicItem.data['Total Population'] || '0'),
          populationHistoricalGrowth2Year: parseFloat(demographicItem.data['2 Year Growth'] || '0') / 100,
          populationProjectedGrowth5Year: parseFloat(demographicItem.data['Household Growth'] || '0') / 100,
          ageAverage: parseFloat(demographicItem.data['Average Age'] || '0'),
          educationCollegeOrDegree: parseFloat(demographicItem.data['Educated'] || '0') / 100,
          householdsPersonsPer: parseFloat(demographicItem.data['Household Size'] || '0'),
          householdsAverageIncome: parseInt(demographicItem.data['Average Income'] || '0'),
          householdsMedianIncome: parseInt(demographicItem.data['Median Income'] || '0')
        };

        // Update demographic data service for PDF export
        this.demographicDataService.updateDemographicData({
          demographics: rawDemographics,
          regionType: this.demographicRegionType,
          regionValue: this.demographicRegionValue
        });
      }
    }

    // Enable PDF export when demographic data is available
    if(this.demographicData && this.demographicData.length > 0){
      this.exportPdfButton = true;
    }
  }



  checkSQftWarning(avg:any,avgSqft:any,bannerName:any,percentage:any) : any{
    const wizard = new SqftWarningWizard();
    wizard.model.updateSqft = 'NO';
    wizard.model.avg = avg;
    wizard.model.bannerName =bannerName;
    wizard.model.avgSqft = avgSqft
    wizard.model.percentage = percentage
    wizard.model.isCrossButtonEvent = true;

    this.wizardRunner.run(wizard).afterClosed()
    .subscribe(() => {
            if(wizard.model.updateSqft == 'YES'){
              this.grocerSqftReset();
              this.newUserForm.controls['sqft'].reset();
              return ;
            }else if(wizard.model.updateSqft == 'CLEAR'){
              this.grocerSqftReset();
              this.newUserForm.controls['sqft'].reset();
              this.grocerSelectionReset();
              return ;
            }
            else{
              this.fetchData();
            }
          });
  }



  getFormData() {
    return {
      grocer: this.newUserForm?.value?.grocer,
      sqft: this.newUserForm?.value?.sqft,
      location: this.wizard?.model?.location
    };
  }

  getSummaryData() {
    return {
      weeklySalesLowerRange: this.weeklySalesLowerRange,
      weeklySalesUpperRange: this.weeklySalesUpperRange,
      areaSales: this.areaSales,
      totalSalesProjectionStatus: this.totalSalesProjectionStatus,
      sqftProjectionStatus: this.sqftProjectionStatus,
      nearestStore: this.nearestStore,
      closetCompetitor: this.closetCompetitor,
      futureStoreCount: this.futureStoreCount,
      nearestFutureStoreDistance: this.nearestFutureStoreDistance,
      nearestFutureStoreName: this.nearestFutureStoreName
    };
  }

  getCompetitiveData() {
    return this.competititveData.map(item => ({
      banner: item.name,
      salesPerSqft: this.keyIndicator === KeyIndicatorType.SALES_VOLUME ? item.value : Number(item.value).toFixed(2),
      value: this.keyIndicator === KeyIndicatorType.SALES_VOLUME ? item.value : Number(item.value).toFixed(2),
      count: item.totalCount
    }));
  }

async captureMapAndExportPdf() {
  try {
    this.exportPdfButtonText = 'Capturing Map...';

    if (this.mapContainer?.nativeElement) {
      const html2canvas = (await import('html2canvas')).default;
      const canvas = await html2canvas(this.mapContainer.nativeElement, {
        useCORS: true,
        allowTaint: true,
        scale: 1,
        logging: false,
        ignoreElements: (element) => {
          return element.classList?.contains('gm-style-cc') ||
                 element.classList?.contains('gmnoprint');
        }
      });
      const mapImage = canvas.toDataURL('image/png');

      if (this.pdfComponent && mapImage) {
        this.pdfComponent.setMapSnapshot(mapImage);
      }
    }

    this.exportPdfButtonText = 'Generating PDF...';
    await this.exportToPdf();

  } catch (error) {
    console.error('Map capture failed:', error);
    this.exportPdfButtonText = 'Generating PDF...';
    await this.exportToPdf();
  }
}




  async exportToPdf() {
    try {
      await this.pdfComponent.exportToPdf();
      this.toaster.info('PDF exported successfully');
    } catch (error) {
      console.error('PDF export failed:', error);
      this.toaster.error('Failed to export PDF');
    } finally {
      this.exportPdfButtonText = 'Export PDF';
    }
  }
}
